var clipboard = new ClipboardJS('.clipboard');

clipboard.on('success', function (e) {
    e.clearSelection();
    $(".clipboard .text-clipboard").text("Cкопійовано");

    setTimeout(function () {
        $(".clipboard .text-clipboard").text("Посилання");

    }, 3000)
});
